import { RefObject, useEffect, useRef } from "react";

import { useAppDispatch } from "store/index";
import { LOCAL_STATE_KEY, LocalState, localStateActions } from "store/slices/local";

export const SCROLL_TRACKING_IDS = {
  PAGE_SIDEBAR: "page-sidebar",
};

export const useScrollRestoration = (
  id: string,
  containerRef: RefObject<HTMLDivElement | null>,
) => {
  const dispatch = useAppDispatch();
  const saveTimeoutRef = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!id || !container) return;

    const saveScrollPosition = (position: number) => {
      if (!id) return;
      dispatch(
        localStateActions.setScrollPosition({
          id,
          position,
        }),
      );
    };

    const getLastScrollPosition = () => {
      try {
        const data = localStorage.getItem(LOCAL_STATE_KEY); // Avoids frequent, unnecessary re-renders
        if (!id || !data) return 0;

        const storedState = JSON.parse(data) as LocalState;
        return storedState.scrollPositions?.[id] || 0;
      } catch (error) {
        console.warn("Error reading scroll position from localStorage:", error);
        return 0;
      }
    };

    const handleScroll = () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
      saveTimeoutRef.current = setTimeout(() => {
        saveScrollPosition(container.scrollTop);
      }, 100);
    };

    container.scrollTop = getLastScrollPosition();
    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, [id, containerRef, dispatch]);
};
